import '@ungap/custom-elements';

window.toastr = require('toastr');

import lozad from 'lozad';
const observer = lozad();
observer.observe();

window.onload = function()
{
    $('.store-locator .link-submit').on('click', e => {
        e.preventDefault();
        $('.store-locator form').submit();
    });

};

/* Select 2 */
require('select2/dist/js/select2.full.js');

require('../../vendor/hegyd-core/js/hegyd-gtm');
require('../../vendor/hegyd-core/js/hegyd-core');

import CartPage from './components/CartPage';
import MainNav from './components/MainNav';
import CartSubmitInput from './components/CartSubmitInput';
import CartSidebar from "./components/CartSidebar";
import CategoryPage from "./components/CategoryPage";

customElements.define('cart-page',CartPage,{extends : 'div'});
customElements.define("main-nav", MainNav, {extends : 'nav'});
customElements.define("cart-submit-input", CartSubmitInput, {extends : 'form'});
customElements.define("cart-sidebar", CartSidebar, {extends : 'div'});
customElements.define('category-page',CategoryPage,{extends: 'div'});



// WEBPACK FOOTER //
// ./resources/assets/js/front/main.js